<template>
  <div>
    <nav-title :title="'Notifications'" :color="false" />

    <section v-if="getNotifications.length == 0" class="d-block text-center mt-5">
      <i class="material-icons full-icon align-middle mt-2 mb-2">notifications</i>
      <p class="text-muted mx-5 text-wrap">
        You don't have any notification yet.
      </p>
    </section>

    <section v-else class="container">
      <b-link class="d-block text-right mt-3 small" @click="removeAll()">
        Clear all notifications
      </b-link>
      <b-list-group class="mt-3 mb-5">
        <b-list-group-item
          v-for="item in getNotifications"
          :key="item.id"
          class="p-2"
          @click.stop="read(item)"
          :class="!item.unread ? '' : userIsAParent ? 'bg-plain' : 'bg-plain2'"
        >
          <b-link class="close" @click.stop="remove(item, true)">
            <i class="material-icons align-middle small">
              close
            </i>
          </b-link>
          <div class="ml-2">
            <p :class="userIsAParent ? 'text-main' : 'text-main2'">
              {{ item.title }}
            </p>
            <p class="text-muted">
              {{ item.description }}
            </p>
            <small class="text-muted">
              {{ formatDate(item.timestamp) }} -
              {{ formatHour(item.timestamp) }}
            </small>
          </div>
        </b-list-group-item>
      </b-list-group>
    </section>
  </div>
</template>

<script>
import navTitle from '@/components/general/navTitle.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('notifications', ['getNotifications', 'getNotificationsCount']),
    ...mapGetters('user', ['getUserId', 'userIsAParent']),
  },
  components: {
    navTitle,
  },

  methods: {
    ...mapActions('notifications', [
      'markAsRead',
      'fethNotifications',
      'dissmissNotification',
      'dissmissAllNotifications',
    ]),
    ...mapActions('user', ['setChildrenSelectedId']),
    formatDate(strdate) {
      var date = new Date(strdate);
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var dayName = days[date.getDay()];
      var day = date.getDate();
      var monthName = months[date.getMonth()];
      //var year = date.getFullYear();
      day = day < 10 ? '0' + day : day;
      var formatted = `${dayName}, ${day} ${monthName}`;
      return formatted;
    },
    formatHour(strdate) {
      var date = new Date(strdate);
      var hours = date.getUTCHours();
      var minutes = date.getUTCMinutes();
      let ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    removeAll() {
      console.log('user is parent', this.userIsAParent);
      this.dissmissAllNotifications({ userId: this.getUserId, isAparent: this.userIsAParent }).then(
        () => {
          this.fethNotifications({
            userIsAparent: this.userIsAParent,
            userId: this.getUserId,
          });
        },
      );
    },
    remove(item) {
      this.dissmissNotification(item.id).then(() => {
        this.fethNotifications({
          userIsAparent: this.userIsAParent,
          userId: this.getUserId,
        });
      });
    },
    read(item) {
      this.markAsRead(item.id).then(() => {
        this.fethNotifications({
          userIsAparent: this.userIsAParent,
          userId: this.getUserId,
        });
        if (item && item.child_id) {
          this.$store.commit('user/setChildrenSelectedId', item.child_id);
          sessionStorage.setItem('clickedChild', `{"id":${item.child_id},"enable":${false}}`);
        }
        if (this.$route.fullPath == item.url) {
          location.reload();
        } else {
          this.$router.push(item.url);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.close {
  z-index: 1;
}
</style>
